export default {
    theme: {
        type: String,
        default: 'professional'
    }
}
